import instance from './instance';

export const fetchMeetingItems = params => instance.get('/meeting_items', { params });

export const fetchSingleMeetingItem = (uuid, params) => instance.get(`/meeting_items/${uuid}`, { params });

export const createNewMeetingItem = data => instance.post('/meeting_items', data);

export const updateCompleteStatus = (slug, data) => instance.put(`/meeting_items/${slug}/toggle`, data);

export const updateParentUuid = data => instance.put(`/meeting_items/nest`, data);

export const updateMeetingItem = (slug, data) => instance.put(`/meeting_items/${slug}`, data);

export const updateAssignee = (slug, data) => instance.put(`/meeting_items/${slug}/update_assignee`, data);

export const attachFile = (slug, data) => instance.putForm(`/meeting_items/${slug}/create_attachment`, data);

export const deleteAttachment = (slug, data) => instance.delete(`/meeting_items/${slug}/destroy_attachment`, { data });

export const deleteMeetingItem = slug => instance.delete(`/meeting_items/${slug}`);

export const removeNesting = (slug, data) => instance.put(`/meeting_items/${slug}/remove_nesting`, data);

export const updateAttachmentPreview = (slug, data) => instance.put(`/meeting_items/${slug}`, data);

export const updateRecurringItem = (slug, data) => instance.put(`/meeting_items/${slug}/upsert_recurrence`, data);

export const deleteRecurrenceItem = (slug, params) =>
  instance.delete(`/meeting_items/${slug}/destroy_recurrence`, { params });

export const createAsanaTask = (slug, data) => instance.put(`/meeting_items/${slug}/create_asana_task`, data);

export const disconnectAsanaTask = (slug, data) => instance.put(`/meeting_items/${slug}/disconnect_asana_task`, data);

export const createJiraIssue = (slug, data) => instance.put(`/meeting_items/${slug}/create_jira_issue`, data);

export const disconnectJiraIssue = (slug, data) => instance.put(`/meeting_items/${slug}/disconnect_jira_issue`, data);

export const createServicenowRecord = (slug, tableName, recordAttributes) =>
  instance.put(`/meeting_items/${slug}/create_servicenow_record`, { tableName, recordAttributes });

export const disconnectServicenowRecord = (slug, data) =>
  instance.put(`/meeting_items/${slug}/disconnect_servicenow_record`, data);

export const addToGoal = (slug, data) => instance.put(`/meeting_items/${slug}/add_to_goal`, data);

export const removeFromGoal = (slug, data) => instance.put(`/meeting_items/${slug}/remove_from_goal`, data);

export const duplicateItems = data => instance.post(`/meeting_items/duplicate_workspace_items`, data);
